export class AnimatedUnderline {
	constructor() {
		const elements: NodeListOf<HTMLElement> = document.querySelectorAll('.animated-underline');

		if (elements.length === 0) {
			return;
		}

		const observer: IntersectionObserver = new IntersectionObserver(this.observerCallback, {
			root: null,
			rootMargin: '0px',
			threshold: [1],
		});

		elements.forEach((item: HTMLElement) => observer.observe(item));
	}

	private observerCallback = (
		entries: IntersectionObserverEntry[],
		observer: IntersectionObserver
	): void => {
		entries.forEach((entry: IntersectionObserverEntry) => {
			if (entry.isIntersecting) {
				const target: HTMLElement = entry.target as HTMLElement;
				target.classList.add('animate');

				observer.unobserve(target);
			}
		});
	};
}
